function renderInputSlider (country, field) {
  let min = fields_json.params.loan_sum.min / 1
  let max = fields_json.params.loan_sum.max / 1
  let step = fields_json.params.loan_sum.step / 1
  let currency = fields_json.params.currency || ''
  return `<style>.main-block__form-range::-webkit-slider-thumb{background: ${$('button[type=submit]').css('background-color')};}.main-block__form-range::-moz-slider-thumb{background: ${$('button[type=submit]').css('background-color')};}</style>
    <div class="form-group ui-form__row two_in_row ${field.hidden ? 'hidden' : ''} columnfield_" style="margin-bottom: 15px">
      <div class="ui-dropdown-field">
        <div class="ui-input ui-dropdown-field__active ui-input_fade">
          <label class="ui-input__container">
            <div class="ui-input__column">
              <input type="tel" name="loan_sum" value="" autocomplete="new-password" autocapitalize="sentences" placeholder="${field.placeholder}" class="ui-input__field" data-required>
              <span class="ui-input__label ui-input__label_mark_required">
                <span class="ui-input__label_placeholder-text">${field.label}</span>
                <span class="ui-input__label_placeholder-hint"></span>
              </span>
            </div>
            <div class="ui-input__additional" style="padding-top: 20px">${currency}</div>
          </label>
        </div>
      </div>
      <div class="main-block__form-slider calc_loan" style="margin-top: -20px">
        <input type="range" step="${step}" min="${min}" max="${max}" class="main-block__form-range" id="loan_sum_range">
      </div>
      <div class="ui-form-field-error-message ui-form-field-error-message_ui-form hidden">${field.error}</div>
    </div>`
}

export { renderInputSlider }